module.exports = __webpack_public_path__ + "img/4-5.ed7b9957.svg";